import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

/**
 * Empty state — BUILD-PLAN §19 ("if there is no data, show an appropriate
 * empty state") and §41.
 *
 * Deliberately composed rather than a bare "No results": an empty wishlist or
 * an unmatched filter is a normal moment in the experience, and §74 requires
 * the design stay visually complete even without content.
 */

interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({ icon: Icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-20 text-center">
      {Icon && (
        <span
          className="mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-surface-muted"
          aria-hidden="true"
        >
          <Icon className="h-6 w-6 text-accent" strokeWidth={1.5} />
        </span>
      )}

      <h2 className="font-display text-xl text-ink">{title}</h2>

      {description && (
        <p className="mt-2 max-w-sm text-sm leading-relaxed text-muted">
          {description}
        </p>
      )}

      {action && <div className="mt-8">{action}</div>}
    </div>
  );
}
